import React from 'react';
import cn from 'classnames';
import { PanelLink } from '@creditflowresearch/uilib/PanelControl';
import { IToolLinkOption } from '@/creditflowresearch/domain/vo/ITools';
import Flex from '@creditflowresearch/uilib/Flex';

import styles from './toolLinkItem.module.scss';

export const ToolLinkItem = ({ link, isActive, onClick, IconComponent, text, badges }: IToolLinkOption) => {
  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };

  return (
    <div className={ cn(styles.toolWrapper, { [styles.active]: isActive }) } data-test="toolWrapper">
      <PanelLink
        to={ link }
        className={ styles.link }
        onClick={ handleClick }
      >
        { IconComponent && <IconComponent className={ styles.toolsIcon } /> }
        { text }
        { badges?.length && badges.map(
          (badge) => (
            <Flex
              justify="center"
              align="center"
              key={ badge }
              className={ cn(styles.badge, styles[badge.toLowerCase()]) }
            >{ badge }
            </Flex>
          ),
      ) }
      </PanelLink>
    </div>
  );
};

export default ToolLinkItem;
